import React from 'react';
import styled from 'styled-components';
import { formatRelative } from 'date-fns';
import { de } from 'date-fns/locale';

import { Link } from 'gatsby';
import dateService from '../../services/date.service';
import { EmergencyService } from '../../models/emergency-service.model';
import { grey } from '../../utils/colors';

interface EmergencyServiceProps {
  service: EmergencyService;
  upcoming?: boolean;
  link?: boolean;
}

export default ({
  service: { pharmacy, untilDate, fromDate },
  upcoming = false,
  link = false,
}: EmergencyServiceProps) => {
  const willChangeDate = upcoming ? fromDate : untilDate;
  const content = (
    <>
      <ServiceTitle>{pharmacy.name}</ServiceTitle>
      <div>Tel. {pharmacy.phone}</div>
      <div>
        {pharmacy.street} <br />
        {pharmacy.zipCode} {pharmacy.location}
      </div>
    </>
  );
  return (
    <ServiceContainer>
      {link ? (
        <ServiceLink to="/notdienst/">{content}</ServiceLink>
      ) : (
        <div>{content}</div>
      )}
      <ServiceChangeNotice>
        {upcoming ? 'beginnt' : 'endet'}{' '}
        {formatRelative(willChangeDate, dateService.date(), { locale: de })} Uhr
      </ServiceChangeNotice>
    </ServiceContainer>
  );
};

const ServiceContainer = styled.div`
  margin-bottom: 20px;
  & p {
    margin-bottom: 0px;
  }
  text-align: center;
`;

const ServiceTitle = styled.h5`
  margin-bottom: 10px;
`;

const ServiceLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  &:hover,
  &:active,
  &:focus {
    text-decoration: underline;
  }
`;

const ServiceChangeNotice = styled.small`
  color: ${grey};
  font-size: 12px;
`;
